import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { useActiveUsers } from 'app/components/active-users/useActiveUsers'
import { ActiveUsersShadcnComponent } from 'app/components/active-users/ActiveUsersShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { useIsOrgUser } from 'app/hooks/useIsOrgUser'
import { useUser } from 'app/utils'

export default observer(function ActiveUsers(): React.ReactElement {
  const me = useUser()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()
  const isOrgUser = useIsOrgUser()
  const { users, columns, filters, initialSort } = useActiveUsers()
  const canEditUser = checkPermission([`org:settings:manage-users`, `users:manage`])

  if (!me) return <></>

  // Staff-v2 only applies when user is in workspace context
  // Org users always use legacy flow
  if (!staffV2Enabled || !me.workspaceId) {
    return <Navigate to="/settings/users" replace />
  }

  // Super users and org users can always access
  // Workspace users need users:manage permission
  const canManageUsers = me.type === `super` || isOrgUser || checkPermission(`users:manage`)
  if (!canManageUsers) {
    return <Navigate to="/" replace />
  }

  return (
    <ActiveUsersShadcnComponent
      users={users}
      columns={columns}
      filters={filters}
      initialSort={initialSort}
      canManageUsers={canManageUsers}
      canEditUser={canEditUser}
      isOrgUser={isOrgUser}
      isSuperUser={me.type === `super`}
    />
  )
})
